export default {
    methods: {
        isMobile: () => {

            const ua = navigator.userAgent.toLocaleLowerCase();
            
            const flag = ua.match(/(phone|pod|iphone|ipod|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone)/i)
            
            const padFlag = ua.match(/iPad/i) == "ipad";

            return flag && flag.length > 0 && !padFlag;
        }
    }
};